import { makeStyles, lighten } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: `2.5px 2.5px 8px ${theme.palette.grey.light}`,
  },
  text: {
    ...theme.typography.button,
  },
  cardHeader: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.header,
    color: theme.palette.text.secondary,
    ...theme.typography.button,
    [theme.breakpoints.down("md")]: {
        padding: theme.spacing(1),
    },
  },
  headerTitle: {
    textAlign: "left",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
        
    },
    [theme.breakpoints.down("xs")]: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
  },
  headerAddButton: {
    textAlign: "right",
    justifyContent: "right",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
        paddingBottom: theme.spacing(1)
    },
  },
  headerAndTopPaginationBGColor: {
    backgroundColor: theme.palette.grey[200],
  },
  paginationHeader: {
    marginBottom: "0px",
    paddingBottom: "0px"
  },
  tableHeader: {
    ...theme.typography.button,
  },
  tableCellFormat: {
    textAlign: "left",
    justifyContent: "center",
    flexDirection: "column",
  },
  centerContentColumn: {
    textAlign: "center",
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
  },
  centerContentRow: {
    display: "inline-block",
    verticalAlign:"middle",
    justifyContent: "right",
    display: "flex",
    [theme.breakpoints.down("md")]: {
    },
  },
  tableButtons: {
    marginLeft: theme.spacing(1),
    
    [theme.breakpoints.up("md")]: {
        justifyContent: "right",
        flexDirection: "column",
        align: "right"
    }
  },
  tableScrolling: {
    overflow: 'auto'
  },
  tableCell: {
    borderBottom: "none",
    wordWrap: "break-word",
  },
  buttonsTableCell: {
    borderBottom: "none",
    paddingRight: theme.spacing(1),
    justifyContent: "right",
    flexDirection: "column",
    align: "right",
  },
  tableRow: {
    borderBottom: `1px solid ${ theme.palette.header}`
  },
  hideForMobile: {
   [theme.breakpoints.down("md")]: {
        display: "none"
    } 
   },
  noDataMessage: {
    paddingTop: theme.spacing(2),
    fontSize: "1.5rem"
  },
  tableContainer: {   
    padding: theme.spacing(1),
    width: "100%",
    display: "block",
    position: "relative"
  },
  table: {
    tableLayout: "fixed",
    width: "100%",
    maxWidth: "100%",
    wordWrap: "break-word"
  },
  reportEmail: {
    display: "block",
    marginTop: '4px'
  },
  reportTypeTag: {
    display: "inline-block",
    backgroundColor: theme.palette.type === 'dark' 
    ? theme.palette.grey[800] 
    : lighten(theme.palette.amano.warnings.warning, 0.8),
    marginTop: '4px',
    padding: "2px 8px",
    borderRadius: "4px",
    border: `1px solid ${theme.palette.common.black}`,
    marginTop: theme.spacing(0.5)
  },
}));
